export default "__VITE_ASSET__DaT_hJT7__"